export const messages = {
  en: {
    equipmentAccount: {
      addEquipment: 'Add Equipment',
      batchPrint: 'Batch Print',
      searchCondition: 'Search Condition',
      listTitle: 'Equipment List',
      hide: 'Hide',
      more: 'More',
      machineName: 'Equipment Name',
      machineNamePlaceholder: 'Please enter equipment name',
      machineCode: 'Equipment Code',
      machineCodePlaceholder: 'Please enter equipment code',
      state: 'Status',
      selectState: 'Please select status',
      importanceLevel: 'Importance Level',
      selectImportanceLevel: 'Please select importance level',
      newLocation: 'New Location',
      selectLocation: 'Please select location',
      selectLocationFirst: 'Please select location first',
      moveEquipment: 'Move Equipment',
      confirmOperation: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this equipment?',
      viewEquipment: 'View Equipment',
      printLabel: 'Print Label',
      printQty: 'Print Quantity',
      printPreview: 'Print Preview',
      importEquipment: 'Import Equipment',
      selectFile: 'Select File',
      fileTip: 'Only .xls, .xlsx files can be uploaded, and no more than 2MB',
      downloadTemplate: 'Download Template',
      downloadTip1: 'Please download',
      downloadTip2: 'to prepare data before uploading',
      selectFileFirst: 'Please select file first',
      invalidFileType: 'Invalid file type, only .xls, .xlsx files are allowed',
      fileSizeExceed: 'File size cannot exceed 2MB',
      selectTypeFirst: 'Please select equipment type first',
      importSuccess: 'Import successfully',
      stateDescription: 'Equipment status: in use, out of service, etc.',
      brand: 'Brand',
      model: 'Model',
      locationDetail: 'Location Detail',
      firstEnableTime: 'First Enable Time',
      warrantyDeadline: 'Warranty Deadline',
      usefulLife: 'Useful Life',
      purchasePrice: 'Purchase Price',
      netWorth: 'Net Worth',
      useOrgName: 'Use Department',
      useUserName: 'User',
      chargeOrgName: 'Responsible Department',
      chargeUseName: 'Responsible Person',
      remark: 'Remark',
      printEquipmentAccount: 'Print Equipment Account',
      selectEquipmentFirst: 'Please select equipment first'
    }
  },
  zh: {
    equipmentAccount: {
      addEquipment: '添加设备',
      batchPrint: '批量打印',
      searchCondition: '查询条件',
      listTitle: '设备列表',
      hide: '隐藏',
      more: '更多',
      machineName: '设备名称',
      machineNamePlaceholder: '请输入设备名称',
      machineCode: '设备编码',
      machineCodePlaceholder: '请输入设备编码',
      state: '状态',
      selectState: '请选择状态',
      importanceLevel: '重要等级',
      selectImportanceLevel: '请选择重要等级',
      newLocation: '新位置',
      selectLocation: '请选择位置',
      selectLocationFirst: '请先选择位置',
      moveEquipment: '移动设备',
      confirmOperation: '确认操作',
      confirmDelete: '确定删除该设备吗？',
      viewEquipment: '查看设备',
      printLabel: '打印标签',
      printQty: '打印数量',
      printPreview: '打印预览',
      importEquipment: '导入设备',
      selectFile: '选择文件',
      fileTip: '只能上传.xls, .xlsx文件，且不超过2MB',
      downloadTemplate: '下载模板',
      downloadTip1: '请先下载',
      downloadTip2: '准备数据后上传导入',
      selectFileFirst: '请先选择文件',
      invalidFileType: '文件类型不正确，只能上传.xls, .xlsx文件',
      fileSizeExceed: '文件大小不能超过2MB',
      selectTypeFirst: '请先选择设备分类',
      importSuccess: '导入成功',
      stateDescription: '设备状态分为：使用中、停用中等状态',
      brand: '品牌',
      model: '型号',
      locationDetail: '位置详情',
      firstEnableTime: '首次启用时间',
      warrantyDeadline: '保修截止日期',
      usefulLife: '使用年限',
      purchasePrice: '采购价格',
      netWorth: '资产净值',
      useOrgName: '使用部门',
      useUserName: '使用人',
      chargeOrgName: '责任部门',
      chargeUseName: '责任人',
      remark: '备注',
      printEquipmentAccount: '打印设备资产标签',
selectEquipmentFirst: '请先选择设备'
    }
  },
  'zh-TW': {
    equipmentAccount: {
      addEquipment: '添加設備',
      batchPrint: '批量列印',
      searchCondition: '查詢條件',
      listTitle: '設備列表',
      hide: '隱藏',
      more: '更多',
      machineName: '設備名稱',
      machineNamePlaceholder: '請輸入設備名稱',
      machineCode: '設備編碼',
      machineCodePlaceholder: '請輸入設備編碼',
      state: '狀態',
      selectState: '請選擇狀態',
      importanceLevel: '重要等級',
      selectImportanceLevel: '請選擇重要等級',
      newLocation: '新位置',
      selectLocation: '請選擇位置',
      selectLocationFirst: '請先選擇位置',
      moveEquipment: '移動設備',
      confirmOperation: '確認操作',
      confirmDelete: '確定刪除該設備嗎？',
      viewEquipment: '查看設備',
      printLabel: '列印標籤',
      printQty: '列印數量',
      printPreview: '列印預覽',
      importEquipment: '導入設備',
      selectFile: '選擇文件',
      fileTip: '只能上傳.xls, .xlsx文件，且不超過2MB',
      downloadTemplate: '下載模板',
      downloadTip1: '請先下載',
      downloadTip2: '準備數據後上傳導入',
      selectFileFirst: '請先選擇文件',
      invalidFileType: '文件類型不正確，只能上傳.xls, .xlsx文件',
      fileSizeExceed: '文件大小不能超過2MB',
      selectTypeFirst: '請先選擇設備分類',
      importSuccess: '導入成功',
      stateDescription: '設備狀態分為：使用中、停用中等狀態',
      brand: '品牌',
      model: '型號',
      locationDetail: '位置詳情',
      firstEnableTime: '首次啟用時間',
      warrantyDeadline: '保修截止日期',
      usefulLife: '使用年限',
      purchasePrice: '採購價格',
      netWorth: '資產淨值',
      useOrgName: '使用部門',
      useUserName: '使用人',
      chargeOrgName: '責任部門',
      chargeUseName: '責任人',
      remark: '備註',
      printEquipmentAccount: '列印設備資產標籤',
      selectEquipmentFirst: '請先選擇設備'
    }
  }
}